import { ConfigProvider, useConfig } from '@context/ConfigContext';
import LoadingScreen from '@components/shared/LoadingScreen/LoadingScreen';
import Header from '@components/Header/Header';
import Hero from '@components/Hero/Hero';
import About from '@components/About/About';
import Services from '@components/Services/Services';
import Testimonials from '@components/Testimonials/Testimonials';
import Portfolio from '@components/Portfolio/Portfolio';
import FAQ from '@components/FAQ/FAQ';
import CTABlock from '@components/CTABlock/CTABlock';
import Contact from '@components/Contact/Contact';
import Footer from '@components/Footer/Footer';
import DevPanel from '@components/DevPanel/DevPanel';

function AppContent() {
  const { config, loading, error, preloadProgress } = useConfig();

  if (loading) {
    return <LoadingScreen progress={preloadProgress?.percentage} />;
  }

  if (error) {
    return (
      <div
        style={{
          padding: '2rem',
          textAlign: 'center',
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexDirection: 'column',
        }}
      >
        <h1>Configuration Error</h1>
        <p>{error}</p>
        <p style={{ marginTop: '1rem', color: '#666' }}>
          Please ensure config.json exists in the public folder.
        </p>
      </div>
    );
  }

  if (!config) {
    return null;
  }

  return (
    <div className="app">
      <Header />
      <Hero />
      <About />
      <Services />
      <Testimonials />
      <CTABlock />
      <Portfolio />
      <FAQ />
      <Contact />
      <Footer />
      <DevPanel />
    </div>
  );
}

function App() {
  return (
    <ConfigProvider>
      <AppContent />
    </ConfigProvider>
  );
}

export default App;